export default __webpack_public_path__ + "static/media/043-technician.eb1d7381.svg";